module.exports = __webpack_public_path__ + "img/wtf.874e47b9.png";